import axios from 'axios';
const API = axios.create({ baseURL: window.location.origin });
API.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// single_session_ui_v1: handle SESSION_REPLACED — bounce to /login
let sessionReplacedHandled = false;
API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const code = error.response?.data?.code;
    /* tenant_suspended_modal_v1: block screen for suspended/inactive tenants */
    if (status === 403 && (code === 'TENANT_SUSPENDED' || code === 'TENANT_INACTIVE')) {
      const reason = (code === 'TENANT_INACTIVE') ? 'inactive' : 'suspended';
      if (typeof window !== 'undefined') {
        window.__tenantBlockReason = reason;
        try {
          window.dispatchEvent(new CustomEvent('tenant-blocked', { detail: { reason } }));
        } catch (e) {}
      }
      return Promise.reject(error);
    }
    /* tenant_suspended_modal_v1: handle TENANT_NOT_FOUND */
    if (status === 401 && code === 'TENANT_NOT_FOUND') {
      if (typeof window !== 'undefined') {
        window.__tenantBlockReason = 'not_found';
        try {
          window.dispatchEvent(new CustomEvent('tenant-blocked', { detail: { reason: 'not_found' } }));
        } catch (e) {}
      }
      return Promise.reject(error);
    }
    if (status === 401 && code === 'SESSION_REPLACED' && !sessionReplacedHandled) {
      sessionReplacedHandled = true;
      try {
        const msg = error.response?.data?.error || 'บัญชีนี้ถูก login จากเครื่องอื่น';
        // Use alert as fallback (toast may not be available outside React tree)
        if (typeof window !== 'undefined') {
          // Try react-hot-toast first if available
          try {
            // Use require-style global if exposed; otherwise alert
            if (window.__toastError) {
              window.__toastError(msg);
            } else {
              alert(msg);
            }
          } catch (e) {
            alert(msg);
          }
        }
      } catch (e) {}
      // Clear auth + redirect
      try { localStorage.removeItem('token'); localStorage.removeItem('tenant'); } catch (e) {}
      // Force full reload to /login so React routes refresh
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default API;
